/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Top Nav Notification Icon component.
 */
export const TopNavNotificationIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M18.7 12.352V8.34a7.194 7.194 0 00-1.972-5.02 7.45 7.45 0 00-4.946-2.311 7.382 7.382 0 00-2.887.439 7.283 7.283 0 00-2.478 1.52A7.133 7.133 0 004.75 5.327a7.025 7.025 0 00-.586 2.811v4.215a4.42 4.42 0 01-.752 2.499c-.269.39-.412.85-.412 1.32v0a2.357 2.357 0 00.715 1.694c.227.223.496.399.793.519.296.12.613.181.933.18h11.981a2.44 2.44 0 001.726-.7 2.358 2.358 0 00.715-1.694v.001c0-.47-.143-.93-.412-1.32a4.42 4.42 0 01-.752-2.5v0zM13.96 20.27c0 .658-.266 1.29-.74 1.756a2.553 2.553 0 01-1.788.728c-.67 0-1.314-.262-1.788-.728a2.462 2.462 0 01-.741-1.756'
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round' />
    </svg>
  );
};
export default TopNavNotificationIcon;
